import React from "react";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toast-theme.css";

const LABELS = {
  success: "Success",
  error: "Error",
  warning: "Heads up",
  info: "Notice",
};

const ICONS = {
  success: "✓",
  error: "✕",
  warning: "!",
  info: "i",
};

function ToastBody({ variant, message }) {
  return (
    <div className={`zt-body zt-body--${variant}`}>
      <span className="zt-chip" aria-hidden="true">
        {ICONS[variant]}
      </span>
      <div className="zt-content">
        <span className="zt-stamp">{LABELS[variant]}</span>
        <span className="zt-message">{String(message)}</span>
      </div>
    </div>
  );
}

const TOAST_METHOD = {
  success: toast.success,
  error: toast.error,
  warning: toast.warn,
  info: toast.info,
};

const BASE_OPTIONS = {
  position: "top-right",
  autoClose: 3500,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  transition: Slide,
};

function fire(variant, message, options) {
  return TOAST_METHOD[variant](<ToastBody variant={variant} message={message} />, {
    ...BASE_OPTIONS,
    className: `zt-toast zt-toast--${variant}`,
    progressClassName: `zt-progress zt-progress--${variant}`,
    ...options,
  });
}

export const notifySuccess = (message, options) => fire("success", message, options);
export const notifyError = (message, options) => fire("error", message, options);
export const notifyWarning = (message, options) => fire("warning", message, options);
export const notifyInfo = (message, options) => fire("info", message, options);
